import "./pagination.css";

const Pagination = ({
  lastPage,
  currentPage,
  onPageChange,
  scrollTargetRef,
}) => {
  if (lastPage <= 1) return null;

  const goToPage = (page) => {
    if (page >= 1 && page <= lastPage) {
      onPageChange(page);

      if (scrollTargetRef?.current) {
        scrollTargetRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  };

  const renderPages = () => {
    const pages = [];
    for (let i = 1; i <= lastPage; i++) {
      if (
        i === 1 ||
        i === lastPage ||
        (i >= currentPage - 2 && i <= currentPage + 2)
      ) {
        pages.push(
          <button
            key={i}
            className={`pagination-btn ${
              currentPage === i ? "active-page" : ""
            }`}
            onClick={() => goToPage(i)}
          >
            {i}
          </button>,
        );
      } else if (
        (i === currentPage - 3 && i > 1) ||
        (i === currentPage + 3 && i < lastPage)
      ) {
        pages.push(
          <span key={i} className="pagination-ellipsis">
            ...
          </span>,
        );
      }
    }
    return pages;
  };

  return (
    <div className="pagination-controls">
      <button
        className="pagination-btn nav-btn"
        onClick={() => goToPage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Previous
      </button>

      {renderPages()}

      <button
        className="pagination-btn nav-btn"
        onClick={() => goToPage(currentPage + 1)}
        disabled={currentPage === lastPage}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
